import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import Preloader from "../components/preloader/Preloader";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import LeadsFollowupsSection from "../components/LeadManagement/LeadsFollowupsSection";

const GET_CALL_STATUS_TYPES = gql`
  query($id: Int!) {
    getCallStatusTypes(id: $id) {
        id
        calling_status
    }
  }
`;

const GET_LEAD_STATUS_TYPES = gql`
  query($institute_id: Int!) {
    getLeadStatusTypes(institute_id: $institute_id) {
        id
        lead_status_type
    }
  }
`;

const GET_LEAD_FOLLOWUP_DATA = gql`
  query($lead_id: Int!) {
    getLeadFollowUpDetails(lead_id: $lead_id) {
        lead_name
        lead_mobile
        father_name
        father_contact_no
        mother_name
        mother_contact_no
        nextFollowUpDate
        status_id
        source_name
        status_name
        followUp_History{
            followUpDate
            employee_id
            employee_name
            comments
          }
    }
  }
`;

class LeadsFollowups extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: Cookies.get("toggle")
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login")
        const getCallStatusTypes = this.props.getCallStatusTypes;
        const loading1 = getCallStatusTypes.loading;
        const error1 = getCallStatusTypes.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        const getLeadStatusTypes = this.props.getLeadStatusTypes;
        const loading2 = getLeadStatusTypes.loading;
        const error2 = getLeadStatusTypes.error
        console.log("getNewEducationalStudents", getCallStatusTypes, getLeadStatusTypes );

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        const getLeadFollowUpDetails = this.props.getLeadFollowUpDetails;
        const loading3 = getLeadFollowUpDetails.loading;
        const error3 = getLeadFollowUpDetails.error

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper mb-2" style={{ minHeight: "50vh" }}>
                    <Container fluid>
                            {
                                loading1 || loading2 || loading3?
                                    (
                                        <Container>
                                            <Row className="my-2">
                                                <Col>
                                                    <div className="spinner-border text-primary text-center loading-img-center"></div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    ) :
                                    (
                                        <LeadsFollowupsSection
                                            getCallStatusTypes={getCallStatusTypes.getCallStatusTypes}
                                            getLeadStatusTypes={getLeadStatusTypes.getLeadStatusTypes}
                                            getLeadFollowUpDetails={getLeadFollowUpDetails.getLeadFollowUpDetails}
                                        />

                                    )
                            }

                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );

    }
}
export default withRouter(compose(
    graphql(GET_CALL_STATUS_TYPES, {
        options: (props) => ({
            variables: {
                id:0,
            },
        }),
        name: "getCallStatusTypes",
    }), graphql(GET_LEAD_STATUS_TYPES, {
        options: (props) => ({
            variables: {
                institute_id: parseInt(Cookies.get("institutionid"))
            },
        }),
        name: "getLeadStatusTypes",
    }), graphql(GET_LEAD_FOLLOWUP_DATA, {
        options: (props) => ({
            variables: {
                lead_id:parseInt(Cookies.get('id')),
            },
        }),
        name: "getLeadFollowUpDetails",
    }),
)(LeadsFollowups));
